import { Component, HostBinding } from '@angular/core';

import version from '../../../../../package.json';
import { BrandProfile } from 'src/environments/brand-profiles';
import { BrandingService } from '../../branding/branding.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @HostBinding('class') classes = 'main-footer';
  readonly brand: BrandProfile;

  constructor(branding: BrandingService) {
    this.brand = branding.brand;
  }
  get currentYear() {
    return new Date().getFullYear();
  }

  get currentAppVersion() {
    return version.version;
  }
}
